//From https://stackoverflow.com/a/14837021

/**
 * Directive to set the focus of the document when an expression becomes true
 */
(function () { 
    angular.module('invesfleet')
        .directive('focusWhen', focusWhen);
    
        focusWhen.$inject = ['$timeout'];
    
        function focusWhen($timeout) {
            return {
                link: function(scope, element, attrs) {
                    scope.$watch(attrs.focusWhen, function(value) {
                        if(value === true) { 
                            $timeout(function() {
                                element[0].focus();
                                scope[attrs.focusWhen] = false;
                            });
                        }
                    });
                }
            };
        }
    })();